__webpack_require__.p = "/TetianaZakharova-portfolio/";